/* eslint-disable-next-line camelcase */
export const hclose_htag_hattrs = /<(\/?)(\w+)(?:\s+([^>]+))?>/;

export function httpTag(state, p) {
  // if closing block tag, clear quotes...
  // but how to tell if tag is block level tag?
  if (state.xMode()) return state.log(p.match);
  if (p.hclose) {
    state.closeTag('h', p.htag);
  } else {
    state.startTag(p.htag, { class: p.hattrs },
      { alt: p.match, type: 'h' });
  }
}
